import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fecb5de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-edit" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "flex1 text-ellipsis" }
const _hoisted_4 = { class: "change-btn" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "flex1 text-ellipsis" }
const _hoisted_7 = { class: "change-btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 关闭 ")


const __default__ = {
  name: 'Entry'
}

import { ref, computed, toRefs } from 'vue'
import { NForm, NFormItem } from 'naive-ui'
import type { FormInst } from 'naive-ui'
import { useAppDialog } from '@/components/appDialog'
import { Nav } from '@teams/common/models'
import useAddOrUpdateNav, {
  DEFAULT_ICON_MAP
} from '@teams/common/hooks/useAddOrUpdateNav'
import SelectFolderInsideGroup from './selectFolderInsideGroup.vue'
import Icon from '@teams/common/components/icon'
import CreateFileName from './createFileName.vue'
import EntryNewNav from './entryNewNav.vue'
import { EnumNavKind } from '@teams/common/api/nav/types'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    initialValue: null
  },
  emits: ["close", "done"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'done'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  initialValue?: Nav
}



const dialog = useAppDialog()
const { initialValue } = toRefs(props)

const {
  form,
  navInfo,
  navInstance,
  selectedViewInfo,
  updateView,
  isGetFileMetadata,
  isGetPath
} = useAddOrUpdateNav({ initialValue: initialValue?.value })

const formRef = ref<FormInst>()
const nameOption = computed(() => {
  return {
    defaultIcon: DEFAULT_ICON_MAP[navInfo.value.type],
    defaultName:
      navInstance.value.type === EnumNavKind.updates
        ? '最近更新'
        : navInfo.value.selectedFile?.name,
    icon: form.icon,
    name: form.name,
    autoUpdate: form.autoUpdate
  }
})
const updateName = params => {
  const { autoUpdate, icon, name } = params
  const data = {
    auto_update: autoUpdate,
    icon,
    name
  }
  Object.keys(data).forEach(key => {
    if (data[key] === undefined) {
      delete data[key]
    }
  })
  updateView(data)
}
// 更改单文件
const changeFile = () => {
  dialog.show({
    title: '选择标签页视图',
    component: EntryNewNav,
    componentProps: {
      hideNameInput: true,
      removeMarginLeft: true
    },
    modalStyle: {
      width: '640px',
      padding: '28px 32px'
    },
    componentEvents: {
      updateType: async context => {
        dialog.back()
        try {
          await updateView({
            kind: context.navType,
            finder: context.finder
          })
        } catch (e) {}
      }
    },
    footer: false
  })
}
// 更改文件夹
const changeFolder = () => {
  dialog.show({
    title: '选择目录',
    component: SelectFolderInsideGroup,
    componentEvents: {
      confirm: async context => {
        await updateView({
          finder: context.finder
        })
      }
    },
    footer: false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NForm), {
      ref_key: "formRef",
      ref: formRef,
      model: _unref(form)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NFormItem), {
          path: "name",
          label: "标签页名称"
        }, {
          default: _withCtx(() => [
            _createVNode(CreateFileName, {
              class: "nav-edit__name-input",
              nameOption: _unref(nameOption),
              onUpdate: updateName
            }, null, 8, ["nameOption"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), {
          path: "navType",
          label: "标签页视图"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "form-item",
              onClick: changeFile
            }, [
              _createElementVNode("div", {
                class: "form-item__left form-item__icon-text",
                title: _unref(selectedViewInfo).name
              }, [
                (_openBlock(), _createBlock(_unref(Icon), {
                  key: _unref(isGetFileMetadata) ? _unref(selectedViewInfo).icon : 'noFolder',
                  name: _unref(isGetFileMetadata) ? _unref(selectedViewInfo).icon : 'noFolder',
                  size: 16,
                  fill: "transparent",
                  class: "form-item__icon"
                }, null, 8, ["name"])),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(isGetFileMetadata)
                  ? _unref(selectedViewInfo).name
                  : '原视图对应的文件已不存在'), 1)
              ], 8, _hoisted_2),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(isGetFileMetadata) ? '更改' : '重新选择'), 1)
            ])
          ]),
          _: 1
        }),
        (!_unref(navInfo).isFile && _unref(selectedViewInfo).name)
          ? (_openBlock(), _createBlock(_unref(NFormItem), {
              key: 0,
              path: "navType",
              label: "视图对应的文件夹"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "form-item",
                  onClick: changeFolder
                }, [
                  _createElementVNode("div", {
                    class: "form-item__left form-item__icon-text",
                    title: _unref(selectedViewInfo).name
                  }, [
                    (_openBlock(), _createBlock(_unref(Icon), {
                      key: _unref(isGetPath) ? _unref(navInfo).selectedFile.icon : 'noFolder',
                      name: _unref(isGetPath) ? _unref(navInfo).selectedFile.icon : 'noFolder',
                      size: 16,
                      fill: "transparent",
                      class: "form-item__icon"
                    }, null, 8, ["name"])),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(isGetPath) ? _unref(navInfo).selectedFile.folderPath : '原文件夹已不存在'), 1)
                  ], 8, _hoisted_5),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(isGetPath) ? '更改' : '重新选择'), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_n_space, {
      class: "content-bottom",
      size: 12,
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})